(function () {
  'use strict';
  // No JS needed for this hero (kept for future enhancements).
})();